/* 9a0f36bbc651f8a7a76499aeda55a4811068fd64
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CategoryDetailQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.CategoryFilterInput>;
}>;


export type CategoryDetailQuery = { __typename?: 'Query', categoryList?: Array<{ __typename?: 'CategoryTree', id?: number | null, short_name?: string | null, name?: string | null, banner?: string | null, banner_head?: string | null, description?: string | null, first_post?: string | null, fourth_post?: string | null, highlight_post?: string | null, category_image_for_app?: string | null, banner_url?: string | null, banner_mobile_image?: string | null, featured_icon?: string | null, meta_title?: string | null, meta_keywords?: string | null, meta_description?: string | null, canonical_url?: string | null, children?: Array<{ __typename?: 'CategoryTree', id?: number | null, name?: string | null, featured_icon?: string | null, is_featured?: boolean | null, url_key?: string | null, url_path?: string | null, url_suffix?: string | null, banner_url?: string | null, canonical_url?: string | null, meta_description?: string | null } | null> | null } | null> | null };

export type CategoryBreadcrumbsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.CategoryFilterInput>;
}>;


export type CategoryBreadcrumbsQuery = { __typename?: 'Query', categoryList?: Array<{ __typename?: 'CategoryTree', breadcrumbs?: Array<{ __typename?: 'Breadcrumb', category_id?: number | null, category_level?: number | null, category_name?: string | null, category_url_key?: string | null, category_url_path?: string | null } | null> | null } | null> | null };

export type HotSearchKeyWordsQueryVariables = Types.Exact<{
  categoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type HotSearchKeyWordsQuery = { __typename?: 'Query', categoryTags?: { __typename?: 'CategoryTags', items?: Array<{ __typename?: 'Tag', created_at?: string | null, identifier?: string | null, meta_description?: string | null, modified_at?: string | null, number_products?: number | null, status?: number | null, tag_id?: number | null, tag_url?: string | null, tag_title?: string | null } | null> | null } | null };


export const CategoryDetailDocument = gql`
    query CategoryDetail($filters: CategoryFilterInput) {
  categoryList(filters: $filters) {
    id
    short_name
    name
    banner
    banner_head
    description
    first_post
    fourth_post
    highlight_post
    category_image_for_app
    banner_url
    banner_mobile_image
    featured_icon
    meta_title
    meta_keywords
    meta_description
    canonical_url
    children {
      id
      name
      featured_icon
      is_featured
      url_key
      url_path
      url_suffix
      banner_url
      canonical_url
      meta_description
    }
  }
}
    `;

/**
 * __useCategoryDetailQuery__
 *
 * To run a query within a React component, call `useCategoryDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryDetailQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCategoryDetailQuery(baseOptions?: Apollo.QueryHookOptions<CategoryDetailQuery, CategoryDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryDetailQuery, CategoryDetailQueryVariables>(CategoryDetailDocument, options);
      }
export function useCategoryDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryDetailQuery, CategoryDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryDetailQuery, CategoryDetailQueryVariables>(CategoryDetailDocument, options);
        }
export function useCategoryDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CategoryDetailQuery, CategoryDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoryDetailQuery, CategoryDetailQueryVariables>(CategoryDetailDocument, options);
        }
export type CategoryDetailQueryHookResult = ReturnType<typeof useCategoryDetailQuery>;
export type CategoryDetailLazyQueryHookResult = ReturnType<typeof useCategoryDetailLazyQuery>;
export type CategoryDetailSuspenseQueryHookResult = ReturnType<typeof useCategoryDetailSuspenseQuery>;
export type CategoryDetailQueryResult = Apollo.QueryResult<CategoryDetailQuery, CategoryDetailQueryVariables>;
export const CategoryBreadcrumbsDocument = gql`
    query CategoryBreadcrumbs($filters: CategoryFilterInput) {
  categoryList(filters: $filters) {
    breadcrumbs {
      category_id
      category_level
      category_name
      category_url_key
      category_url_path
    }
  }
}
    `;

/**
 * __useCategoryBreadcrumbsQuery__
 *
 * To run a query within a React component, call `useCategoryBreadcrumbsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryBreadcrumbsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryBreadcrumbsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCategoryBreadcrumbsQuery(baseOptions?: Apollo.QueryHookOptions<CategoryBreadcrumbsQuery, CategoryBreadcrumbsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryBreadcrumbsQuery, CategoryBreadcrumbsQueryVariables>(CategoryBreadcrumbsDocument, options);
      }
export function useCategoryBreadcrumbsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryBreadcrumbsQuery, CategoryBreadcrumbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryBreadcrumbsQuery, CategoryBreadcrumbsQueryVariables>(CategoryBreadcrumbsDocument, options);
        }
export function useCategoryBreadcrumbsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CategoryBreadcrumbsQuery, CategoryBreadcrumbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoryBreadcrumbsQuery, CategoryBreadcrumbsQueryVariables>(CategoryBreadcrumbsDocument, options);
        }
export type CategoryBreadcrumbsQueryHookResult = ReturnType<typeof useCategoryBreadcrumbsQuery>;
export type CategoryBreadcrumbsLazyQueryHookResult = ReturnType<typeof useCategoryBreadcrumbsLazyQuery>;
export type CategoryBreadcrumbsSuspenseQueryHookResult = ReturnType<typeof useCategoryBreadcrumbsSuspenseQuery>;
export type CategoryBreadcrumbsQueryResult = Apollo.QueryResult<CategoryBreadcrumbsQuery, CategoryBreadcrumbsQueryVariables>;
export const HotSearchKeyWordsDocument = gql`
    query HotSearchKeyWords($categoryId: Int) {
  categoryTags(category_id: $categoryId) {
    items {
      created_at
      identifier
      meta_description
      modified_at
      number_products
      status
      tag_id
      tag_url
      tag_title
    }
  }
}
    `;

/**
 * __useHotSearchKeyWordsQuery__
 *
 * To run a query within a React component, call `useHotSearchKeyWordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotSearchKeyWordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotSearchKeyWordsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useHotSearchKeyWordsQuery(baseOptions?: Apollo.QueryHookOptions<HotSearchKeyWordsQuery, HotSearchKeyWordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HotSearchKeyWordsQuery, HotSearchKeyWordsQueryVariables>(HotSearchKeyWordsDocument, options);
      }
export function useHotSearchKeyWordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HotSearchKeyWordsQuery, HotSearchKeyWordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HotSearchKeyWordsQuery, HotSearchKeyWordsQueryVariables>(HotSearchKeyWordsDocument, options);
        }
export function useHotSearchKeyWordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HotSearchKeyWordsQuery, HotSearchKeyWordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HotSearchKeyWordsQuery, HotSearchKeyWordsQueryVariables>(HotSearchKeyWordsDocument, options);
        }
export type HotSearchKeyWordsQueryHookResult = ReturnType<typeof useHotSearchKeyWordsQuery>;
export type HotSearchKeyWordsLazyQueryHookResult = ReturnType<typeof useHotSearchKeyWordsLazyQuery>;
export type HotSearchKeyWordsSuspenseQueryHookResult = ReturnType<typeof useHotSearchKeyWordsSuspenseQuery>;
export type HotSearchKeyWordsQueryResult = Apollo.QueryResult<HotSearchKeyWordsQuery, HotSearchKeyWordsQueryVariables>;